import { SalesOrderStatus } from '../constants/sales-order-status.js';
import { SALES_ORDER_PICKING_STATUS_IDS } from './sales-order-picking-status-ids.js';
/** The statuses at which the run's pick is open: Accepted, plus Delivery Scheduling on the auto path, and none once the pick is committed. */
export function salesOrderPickOpenStatusIds({ readyToDeliverMode, inventoryCommitted, }) {
    if (inventoryCommitted)
        return [];
    return readyToDeliverMode === 'auto'
        ? SALES_ORDER_PICKING_STATUS_IDS
        : [SalesOrderStatus.ACCEPTED];
}
//# sourceMappingURL=sales-order-pick-open-status-ids.js.map